import { CDN_IMAGES_URL } from 'consts/global';

export const DEFAULT_CARD_NETWORKS_SUPPORTED = ['visa', 'mastercard'];

export enum DigitalWalletProvider {
  APPLE_PAY = 'apple_pay',
  GOOGLE_PAY = 'google_pay'
}

export const DIGITAL_WALLET_PROVIDERS_FRIENDLY_NAME = {
  [DigitalWalletProvider.APPLE_PAY]: 'Apple Pay',
  [DigitalWalletProvider.GOOGLE_PAY]: 'Google Pay'
};

export const DIGITAL_WALLET_PROVIDERS_CDN_IMAGE_URL = {
  [DigitalWalletProvider.APPLE_PAY]: `${CDN_IMAGES_URL}/apple-pay-icon-black.svg`,
  [DigitalWalletProvider.GOOGLE_PAY]: `${CDN_IMAGES_URL}/google-pay-icon-color.svg`
};

export * from './applePay';
export * from './googlePay';
